/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useTableStyles = makeStyles(theme => ({
  headerTableCell: {
    padding: '0 10px 15px',
    minHeight: '52px',
    color: theme.palette.text.primary,
    fontSize: '12px',
    lineHeight: '15px',
    textTransform: 'uppercase',
    borderWidth: '2px',
  },
  bodyTableCell: {
    height: '52px',
    padding: '10px',
    borderBottom: '1px solid #eeeeee',
    '&$smallCell': {
      height: '32px',
    },
  },
  bodyTableCellText: {
    fontSize: '14px',
    lineHeight: '14px',
  },
  smallCell: {},
  checkboxTableCell: {
    padding: '0 10px 0 0',
  },
  rowChecked: {
    backgroundColor: '#eeeeee',
  },
  checkboxCell: {
    paddingLeft: '0px',
    display: 'flex',
    alignItems: 'center',
  },
  textAlignRight: {
    textAlign: 'right',
  },
  limitTextColumn: {
    maxWidth: '220px',
  },
}));
